import * as React from 'react';
import classnames from 'classnames';

import InfluencerVerificationLabel from 'components/influencer-verification-label/InfluencerVerificationLabel';

import './creator-tile-artist-name.scss';

import type { CreatorTile } from 'types';

type Props = {
  influencer: CreatorTile,
  url: string,
  shaded?: boolean
};

class CreatorTileArtistName extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { shaded, influencer, url } = this.props;

    if (!influencer.name) {
      return null;
    }

    const linkClasses = classnames({
      'text-overflow-ellipsis': true,
      'creator-tile-artist-name__link': true,
      'creator-tile-artist-name__link--shaded': shaded
    });

    return (
      <div className="creator-tile-artist-name">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          title={influencer.name}
          className={linkClasses}
          data-qa="creator-tile-artist-name"
        >
          {influencer.name}
        </a>
        {
          influencer && (
            <div className="creator-tile-artist-name__verification-label">
              <InfluencerVerificationLabel
                withMargin
                type={influencer.isLightweight ? 'unverified' : 'verified'}
              />
            </div>
          )
        }
      </div>
    );
  }
}

export default CreatorTileArtistName;
